module.exports = __webpack_public_path__ + "static/homePageTopBackground-85176f7e086f4a94429eecb04ae66535.png";